const tableAttrOrProp = {
  defaultColWidth: 200,
  scroll: { y: 540 },
};

export function getTableAttrOrProp(props = {}) {
  return Object.assign({}, tableAttrOrProp, props);
}

export function getTableAttrOrPropWithRowCheckbox(selectedKey = "id") {
  return getTableAttrOrProp({
    rowCheckbox: true,
    selectedKey,
  });
}

export const getSubmitActionConfig = (text = "保存", customAttrOrProp = {}) => [
  {
    type: "submit",
    text,
    attrOrProp: {
      ...customAttrOrProp,
      raised: true,
    },
  },
];

export const actionConfig = [
  ...getSubmitActionConfig(),
  {
    type: "cancel",
    text: "返回",
  },
];

export const dialogActionConfig = [
  {
    type: "submit",
    text: "保存",
    attrOrProp: {
      raised: true,
    },
  },
  {
    type: "close",
    text: "关闭",
    attrOrProp: {
      outlined: true,
    },
  },
];
